// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ol-tooltip {
  position: fixed;
  box-sizing: border-box;
  background: #FFFFFF;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-radius: 3px;
  padding: 10px;
  z-index: 1000;
  cursor: auto;
  min-width: min(165px, calc(100vw - 16px)) !important;
  max-width: calc(100vw - 16px);
  overflow-wrap: anywhere;
  margin-top: 5px;
}
.ol-body {
  font-family: Karla, Nunito Sans, Helvetica, Arial, sans-serif !important;
}
.ol-title {
  font-family: Karla, Roboto Condensed, Helvetica, Arial, sans-serif !important;
  font-weight: bold !important;
}
.ol-tooltip-text {
  margin: 0 0 6px;
  white-space: normal;
  font-size: 12px;
  line-height: 1.333333;
  color: var(--tooltipTextColor);
}
.ol-close-text {
  background: transparent;
  border: 0;
  color: var(--tooltipTextColor);
  font: inherit;
  padding: 20px 10px;
  margin: -20px 0;
  float: right;
  cursor: pointer;
}

.ol-close-text:focus-visible {
  outline: 2px solid #ffffff;
  outline-offset: 2px;
  box-shadow: 0 0 0 5px #000000;
}

.ol-tooltip-text-body {
  margin-top: 10px;
}


.ol-inline {
  display: inline;
}


@media (min-width: 996px) {
  .ol-close-text {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/cta/css/tooltip.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,YAAY;EACZ,oDAAoD;EACpD,6BAA6B;EAC7B,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,wEAAwE;AAC1E;AACA;EACE,6EAA6E;EAC7E,4BAA4B;AAC9B;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,8BAA8B;AAChC;AACA;EACE,uBAAuB;EACvB,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;;AAGA;EACE,eAAe;AACjB;;;AAGA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".ol-tooltip {\n  position: fixed;\n  box-sizing: border-box;\n  background: #FFFFFF;\n  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);\n  border-radius: 3px;\n  padding: 10px;\n  z-index: 1000;\n  cursor: auto;\n  min-width: min(165px, calc(100vw - 16px)) !important;\n  max-width: calc(100vw - 16px);\n  overflow-wrap: anywhere;\n  margin-top: 5px;\n}\n.ol-body {\n  font-family: Karla, Nunito Sans, Helvetica, Arial, sans-serif !important;\n}\n.ol-title {\n  font-family: Karla, Roboto Condensed, Helvetica, Arial, sans-serif !important;\n  font-weight: bold !important;\n}\n.ol-tooltip-text {\n  margin: 0 0 6px;\n  white-space: normal;\n  font-size: 12px;\n  line-height: 1.333333;\n  color: var(--tooltipTextColor);\n}\n.ol-close-text {\n  background: transparent;\n  border: 0;\n  color: var(--tooltipTextColor);\n  font: inherit;\n  padding: 20px 10px;\n  margin: -20px 0;\n  float: right;\n  cursor: pointer;\n}\n\n.ol-close-text:focus-visible {\n  outline: 2px solid #ffffff;\n  outline-offset: 2px;\n  box-shadow: 0 0 0 5px #000000;\n}\n\n.ol-tooltip-text-body {\n  margin-top: 10px;\n}\n\n\n.ol-inline {\n  display: inline;\n}\n\n\n@media (min-width: 996px) {\n  .ol-close-text {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
